import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../../components/Logo";
import { useI18n } from "../../i18n/I18nContext";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
    const { t } = useI18n();
    const { user, login, loading } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    if (!loading && user?.role === "admin") {
        return <Navigate to="/admin" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-brand-navy text-white flex items-center justify-center px-4">
            <div className="w-full max-w-md bg-white text-brand-navy p-10" data-testid="admin-login-card">
                <div className="flex justify-center mb-8">
                    <Logo />
                </div>
                <h1 className="font-display text-3xl text-center mb-2">{t("admin.login_title")}</h1>
                <div className="w-12 h-px bg-brand-gold mx-auto mb-8" />
                <form onSubmit={submit} className="space-y-5">
                    <label className="block">
                        <span className="text-[0.65rem] tracking-[0.22em] uppercase font-bold">{t("admin.email")}</span>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="admin-email"
                            className="w-full mt-1.5 bg-white border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-brand-gold transition"
                        />
                    </label>
                    <label className="block">
                        <span className="text-[0.65rem] tracking-[0.22em] uppercase font-bold">{t("admin.password")}</span>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="admin-password"
                            className="w-full mt-1.5 bg-white border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-brand-gold transition"
                        />
                    </label>
                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="admin-login-submit"
                        className="w-full inline-flex items-center justify-center px-6 py-4 bg-brand-gold hover:bg-brand-gold-deep disabled:opacity-60 text-white text-[0.72rem] tracking-[0.24em] uppercase font-semibold transition-colors"
                    >
                        {busy ? t("admin.logging_in") : t("admin.login")}
                    </button>
                </form>
            </div>
        </div>
    );
}
